import React, { type ReactElement } from "react";

import { useTranslations } from "@rootreeweb/react-translations";

import type { FillOption, PouchType } from "../types.js";
import Headings from "./Headings.js";
import Size from "./Size.js";

type Props = {
	pouch: PouchType;
};

/**
 *
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function Table(props: Props): ReactElement {
	const { pouch } = props;
	const { sizes } = pouch;
	const { getTranslationString } = useTranslations();
	const fillOptions: FillOption[] = [
		{
			hasAny: sizes.some((size) => size.maxFill),
			label: getTranslationString("max-fill"),
		},
		{
			hasAny: sizes.some((size) => size.reccFill),
			label: getTranslationString("recc-fill"),
		},
	];

	const hasAny = fillOptions.some((fillOption) => fillOption.hasAny);
	return (
		<table>
			<thead>
				<Headings fillOptions={fillOptions} hasAny={hasAny} />
			</thead>
			<tbody>
				{sizes.map((size, index) => (
					<Size hasAny={hasAny} key={index} size={size} />
				))}
			</tbody>
			<tfoot>
				<Headings fillOptions={fillOptions} hasAny={hasAny} />
			</tfoot>
		</table>
	);
}
